import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { actionCreators } from "../redux/agreementsAnalysisSagas";

export function UpdateBtns() {
  const dispatch = useDispatch();

  const filtersDirty = useSelector((state) => state.agreementsAnalysis.filtersDirty);

  return (
    filtersDirty && (
      <div className="action-buttons">
        <button className="submit" onClick={() => dispatch(actionCreators.updateData())}>
          Update
        </button>
        <button className="submit reset" onClick={() => dispatch(actionCreators.resetFilters())}>
          Reset
        </button>
      </div>
    )
  );
}
